import { Component } from '@angular/core';
import { SidebarNavMenuItem } from '../../../../decorators/sidebar-nav-menu-item';

@SidebarNavMenuItem({
  route: '/my-requisition',
  faIcon: 'list_alt',
  name: 'my-requisition',
  order: 150
})
@Component({
  selector: 'app-my-requisition',
  templateUrl: './my-requisition.component.html',
  styleUrl: './my-requisition.component.css'
})
export class MyRequisitionComponent {

}
